import React from "react";

export default function BrandLogo({ variant = "light", showProduct = true, className = "" }) {
  const isDark = variant === "dark";
  const textColor = isDark ? "text-white" : "text-equipr-black";
  return (
    <div className={`flex items-center gap-2 select-none ${className}`} data-testid="brand-logo">
      <div className="flex items-center">
        <span className={`font-extrabold text-lg tracking-tight ${textColor}`}>EQUIPR</span>
      </div>
      {showProduct && (
        <span className={`text-[10px] font-semibold tracking-[0.2em] uppercase ${isDark ? "text-equipr-yellow" : "text-gray-500"}`}>
          Civil
        </span>
      )}
    </div>
  );
}
